import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import SignUpForm from "../components/SignUpForm";
import useTitle from "../components/Title";

const SignUp = () => {

  useTitle("- Sign Up");
  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">
          <SignUpForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SignUp;
